// extracted by mini-css-extract-plugin
export default {"hr":"HR_hr__4uyO4"};